// contexts/ScrollContext.js
import { createContext, useRef } from "react";

export const ScrollContext = createContext();

export const ScrollProvider = ({ children }) => {
  const scrollRef = useRef(null);

  return (
    <ScrollContext.Provider value={{ scrollRef }}>
      <div ref={scrollRef} className="overflow-y-auto h-screen">
        {children}
      </div>
    </ScrollContext.Provider>
  );
};
